<template>
  <div class="progress-bar-metric">
    <v-progress-linear
      :value="progressBarValue"
      height="16"
      background-color="lightGrey"
      class="progress-bar-metric__bar"
      :aria-label="accessibleLabel"
    />
    <div v-if="rangeStartLabel || rangeEndLabel" class="progress-bar-metric__labels">
      <Typography variant="subtitle-1" class="progress-bar-metric__start">
        {{ rangeStartLabel }}
      </Typography>
      <Typography v-if="rangeEndLabel" variant="body-1">{{ rangeEndLabel }}</Typography>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "ProgressBarMetric",
  components: { Typography },
  props: {
    progress: { type: Number, default: 0 },
    rangeStartLabel: { type: String, default: "" },
    rangeEndLabel: { type: String, default: "" },
    accessibleName: { type: String, default: "" },
  },
  computed: {
    progressBarValue() {
      return this.progress * 100;
    },
    accessibleLabel() {
      const percent = `${Math.round(this.progressBarValue)}% complete`;
      return this.accessibleName ? `${this.accessibleName}: ${percent}` : percent;
    },
  },
};
</script>

<style scoped>
.progress-bar-metric {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}

.progress-bar-metric__bar {
  border-radius: 16px;
}

/* v-progress-linear takes a single `color`, so the brand gradient can only be
   applied to the fill directly. Theme vars keep it tokenized. */
.progress-bar-metric__bar ::v-deep .v-progress-linear__determinate {
  background: linear-gradient(to right, var(--v-brandCyan-base), var(--v-brandGreen-base));
}

.progress-bar-metric__labels {
  justify-content: space-between;
  display: flex;
  gap: 2px;
}

.progress-bar-metric__start {
  min-width: 0;
}
</style>
